// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadcrumbRoot_container__Vg0zt"};